import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm border-b border-stone-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
        <div className="flex flex-col leading-tight cursor-pointer" onClick={() => scrollTo('hero')}>
          <span
            className={`text-lg font-bold tracking-wide transition-colors ${
              scrolled ? 'text-[#1A3A52]' : 'text-white'
            }`}
          >
            Dr. Dan Oliver Höftmann
          </span>
          <span
            className={`text-xs font-light tracking-widest uppercase transition-colors ${
              scrolled ? 'text-stone-500' : 'text-white/80'
            }`}
          >
            Rechtsanwalt · Rostock
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Über mich', id: 'ueber-mich' },
            { label: 'Rechtsgebiete', id: 'rechtsgebiete' },
            { label: 'Leistungen', id: 'leistungen' },
            { label: 'Kontakt', id: 'kontakt' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-700 hover:text-[#1A3A52]' : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('kontakt')}
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'bg-[#1A3A52] text-white hover:bg-[#0f2638]'
                : 'bg-white/20 text-white border border-white/40 hover:bg-white/30'
            }`}
          >
            Termin anfragen
          </button>
        </div>

        <button
          className={`md:hidden cursor-pointer transition-colors ${scrolled ? 'text-[#1A3A52]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-8 py-4 flex flex-col gap-4">
          {[
            { label: 'Über mich', id: 'ueber-mich' },
            { label: 'Rechtsgebiete', id: 'rechtsgebiete' },
            { label: 'Leistungen', id: 'leistungen' },
            { label: 'Kontakt', id: 'kontakt' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-left text-stone-700 font-medium text-sm cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
